module.exports = __webpack_public_path__ + "static/media/ic-mais-vida.e1da4bb3.svg";